import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-view-permiso',
  templateUrl: './dialog-view-permiso.component.html',
  styleUrls: ['./dialog-view-permiso.component.css']
})
export class DialogViewPermisoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
